import { Injectable } from "@angular/core";
import { AlertController } from "ionic-angular";


@Injectable()

export class DebugProvider {
    constructor(private alertCtrl: AlertController) {}

    log(content: any) {
        let alert = this.alertCtrl.create({
            title: 'Debug',
            message: JSON.stringify(content),
        })

        alert.present();
    }
}




// WEBPACK FOOTER //
// ./src/providers/debug.ts